import PropTypes from 'prop-types';

import ApplicationFooter from '@frolight/components/ApplicationFooter';
import ApplicationHeader from '@frolight/components/ApplicationHeader';
import LocaleSelector from '@frolight/components/LocaleSelector';
import useUserPreferences from '@frolight/hooks/useUserPreferences';

const PageLayout = ({ children }) => {
  const { userPreferences } = useUserPreferences();

  return (
    <div className="page_wrapper">
      <div className="page_wrapper__content">
        <ApplicationHeader />
        <main className="page_wrapper__main" aria-live="polite">
          { !userPreferences?.locale && <LocaleSelector theme='dark'/> }
          { children }
        </main>
        <ApplicationFooter />
      </div>
    </div>
  );

};

PageLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default PageLayout;
